import Vue from 'vue'
import Router from 'vue-router'
import { getAtlasInfo } from '@/setup/atlasInfo'
import communitiesRoutes from './modules/communities'

const PublicHome = () => import(/* webpackChunkName: "public" */ '../pages/public/PublicHome')
const AllCourses = () => import(/* webpackChunkName: "public" */ '../pages/public/AllCoursesPublic')
const UnitPlan = () => import(/* webpackChunkName: "public" */ '../pages/public/UnitPlanPublic')
const CourseMapIndex = () => import(/* webpackChunkName: "public-course-map" */ '../pages/courseMap/CourseMapIndex')
const CourseMapMainPage = () => import(/* webpackChunkName: "public-course-map" */ '../pages/courseMap/components/CourseMapMainPage')
const CourseMapUnitCalendarYear = () => import(/* webpackChunkName: "public-course-map" */ '../pages/courseMap/components/unitCalendar/UnitCalendarYear')
const CourseMapUnitCalendarMonth = () => import(/* webpackChunkName: "public-course-map" */ '../components/calendar/month/CalendarMonth')
const CourseMapDescription = () => import(/* webpackChunkName: "public-course-map" */ '../pages/courseMap/subpages/DescriptionEditor')
const CoursePlanMainPage = () => import(/* webpackChunkName: "course-map" */ '@/pages/courseMap/components/coursePlan/CoursePlanMainPage.vue')
const UnitCompareCurriculum = () => import(/* webpackChunkName: "course-map" */ '@/pages/courseMap/components/coursePlan/CompareCurriculum.vue')
const LessonSharedWithLink = () => import(/* webpackChunkName: "course-map" */ '@/pages/public/LessonSharedWithLink.vue')

const Login = () => import(/* webpackChunkName: "service" */ '../pages/public/Login')
const PageNotFound = () => import(/* webpackChunkName: "service" */ '../pages/PageNotFound')
const ServerError = () => import(/* webpackChunkName: "service" */ '../pages/ServerError.vue')
const AccessDenied = () => import(/* webpackChunkName: "service" */ '../pages/AccessDenied')

Vue.use(Router)
const validateIdParam = (to, from, next) => {
  if (to.params.id === undefined || Number.isInteger(+to.params.id)) next()
  else next({ name: 'PageNotFound', replace: true })
}
const routes = [
  { path: '/', name: 'Root', redirect: { name: 'PublicHome' } },
  // todo: remove for login all unnecessary requests like header-menu and etc - if we need only name of school and logo we can create special request for this.
  { path: '/login', name: 'PublicLogin', component: Login },
  { path: '/home', name: 'PublicHome', component: PublicHome },
  {
    path: '/course-map/:id',
    name: 'CourseMap',
    component: CourseMapIndex,
    beforeEnter: validateIdParam,
    children: [
      {
        path: 'description',
        name: 'CourseMapDescription',
        component: CourseMapDescription
      },
      {
        path: 'unit-calendar',
        name: 'UnitCalendar',
        component: CourseMapMainPage,
        redirect: { name: 'UnitCalendarYear' },
        children: [
          {
            path: 'year',
            name: 'UnitCalendarYear',
            component: CourseMapUnitCalendarYear
          },
          {
            path: 'month',
            name: 'CalendarMonth',
            component: CourseMapUnitCalendarMonth
          }
        ]
      },
      {
        path: 'course-plan',
        name: 'CoursePlan',
        component: CoursePlanMainPage,
        redirect: { name: 'UnitCompareCurriculum' },
        children: [
          {
            path: 'curriculum',
            name: 'UnitCompareCurriculum',
            component: UnitCompareCurriculum
          }
        ]
      }
    ]
  },
  // All Courses
  {
    path: '/all-public-curriculum/all-courses',
    name: 'AllCoursesPublic',
    component: AllCourses
  },
  {
    path: '/server-error',
    name: 'ServerError',
    component: ServerError
  },
  {
    path: '*/page-not-found',
    name: 'PageNotFound',
    component: PageNotFound
  },
  {
    path: '/access-denied',
    name: 'AccessDenied',
    component: AccessDenied
  },
  // Unit Plan
  {
    path: '/unit-planner/:id',
    name: 'UnitPlannerPublic',
    beforeEnter: validateIdParam,
    component: UnitPlan
  },
  // Lesson Shared With Link
  {
    path: '/lesson/shared/:id',
    name: 'LessonSharedWithLink',
    beforeEnter: validateIdParam,
    component: LessonSharedWithLink
  },
  // Communities
  ...communitiesRoutes
  // TODO: uncomment after SPA fully implementation
  // {
  //   path: '*',
  //   redirect: {
  //     name: 'PageNotFound'
  //   }
  // }
]

const router = new Router({
  mode: 'history',
  linkActiveClass: 'active',
  base: '/',
  routes
})
router.beforeEach(async (to, from, next) => {
  const info = await getAtlasInfo(to.fullPath)

  // View-only shared lesson link page
  if (to.name === 'LessonSharedWithLink') return next()

  if (to.path !== '/home' && !info.isPublicSiteEnabled) {
    return next('/home')
  }
  next()
})
/**
 * https://github.com/vuejs/vue-router/issues/2593#issuecomment-741016999
 * use this instead of scrollBehavior in options passed to Router constructor
 */
router.afterEach((to) => {
  window.scrollTo(0, to.meta.scrollTop || 0)
})

export default router
